<template>
	<div ref="trustbox" class="trustpilot-widget mt-16" :data-locale="locale" :data-template-id="templateId" data-businessunit-id="619813800c5541f7f6f02b42" :data-style-height="height" data-style-width="100%" data-theme="light" data-stars="4,5" data-review-languages="da">
		<a href="https://dk.trustpilot.com/review/fototiles.dk" target="_blank" rel="noopener">Trustpilot</a>
	</div>
</template>

<script>
const localeMapping = {
    'da': 'da-DK',
    'nb': 'nb-NO',
    'sv': 'sv-SE',
};

export default {
    data() {
        return {
            locale: localeMapping[this.$page.props.__locale],
            templateId: this.$page.props.__locale === 'da' ? '53aa8912dec7e10d38f59f36' : '5406e65db0d04a09e042d5fc',
            height: this.$page.props.__locale === 'da' ? '140px' : '28px',
        };
    },
    mounted() {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(this.$refs.trustbox, true);
        }
    },
}
</script>
